// GENERATED BY ops/run-fz/build-frozen.mjs — DO NOT EDIT BY HAND.
// Every string below was driven through the live pipeline. Captured in 2 sittings:
//   2026-09-01T06:33:47Z @ d27923a0c8573b1ac1a37f6b8f9e9e7520d8c44b
//   2026-08-31T23:03:33Z..23:04:57Z @ 8b8d36e212e1a8bb8437de4c5e54c51a6c2e8aaf
// 🔴 THE DATE THAT GOVERNS AN ANSWER IS THE ONE ON THAT ANSWER (capturedAt / tipSha on each
// entry), never the pair below — the file holds captures from more than one sitting.
// Editing one stops it being a capture. To change an answer, change the QUESTION and re-capture:
// see the header of the generator for the four steps.
//
// 🔴 THE KEY IS THE CHIP'S EXACT TEXT. Lookup is a plain Map.get on the raw string — no trim, no
// lowercase, no normalisation — so chip text hits and one character different misses and goes live.
// ⚠️ Deliberately NOT normQuestion (steel answerCache.js:28): that strips terminal punctuation, so
// "…Catrett." and "…Catrett" would collide, which is exactly the near-match a freeze must not have.

export const FROZEN_CAPTURED_AT = "2026-09-01T06:33:47Z";
export const FROZEN_TIP_SHA = "d27923a0c8573b1ac1a37f6b8f9e9e7520d8c44b";

const ENTRIES = [
  [
    "When can a federal court exercise supplemental jurisdiction over state law claims?",
    {
      "capturedAt": "2026-09-01T06:33:47Z",
      "tipSha": "d27923a0c8573b1ac1a37f6b8f9e9e7520d8c44b",
      "kind": "research",
      "scope": "all",
      "answerId": null,
      "prose": "A federal court's power to hear state law claims joined with claims that independently support federal jurisdiction is governed by 28 U.S.C. § 1367, which codified and expanded the judge-made doctrines of pendent and ancillary jurisdiction. Under § 1367(a), once a district court has original jurisdiction over any claim in an action, it has supplemental jurisdiction over all other claims that are so related to claims in the action within the court's original jurisdiction that they form part of the same case or controversy under Article III of the United States Constitution. This standard derives from United Mine Workers of America v. Gibbs, 383 U.S. 715 (1966), which held that state and federal claims must derive from a common nucleus of operative fact such that a plaintiff would ordinarily be expected to try them in one judicial proceeding; if so, the entire action comprises but one constitutional case.\n\nSection 1367(a) further provides that supplemental jurisdiction includes claims involving the joinder or intervention of additional parties, resolving the older ancillary-jurisdiction limits that had constrained claims by or against parties other than the original plaintiff and defendant, as discussed in Owen Equipment & Erection Co. v. Kroger, 437 U.S. 365 (1978), which had held that ancillary jurisdiction could not be used to circumvent the complete-diversity requirement by allowing a plaintiff to assert a claim against a nondiverse third-party defendant.\n\nSection 1367(b), however, carves out important limits in cases where the district court's original jurisdiction is founded solely on diversity of citizenship under 28 U.S.C. § 1332. In such diversity-only cases, the court has no supplemental jurisdiction over claims by plaintiffs against persons made parties under Rules 14, 19, 20, or 24, or over claims by persons proposed to be joined as plaintiffs under Rule 19 or seeking to intervene as plaintiffs under Rule 24, when exercising jurisdiction over those claims would be inconsistent with the jurisdictional requirements of § 1332. The Supreme Court explained the interaction between § 1367(a) and (b) in Exxon Mobil Corp. v. Allapattah Services, Inc., 545 U.S. 546 (2005), holding that § 1367 permits supplemental jurisdiction over claims by additional plaintiffs who do not independently satisfy the amount-in-controversy requirement, so long as at least one named plaintiff satisfies the jurisdictional amount and diversity is complete, because § 1367(b) does not exclude such claims from its scope.\n\nEven where the statutory requirements of § 1367(a) are met, the exercise of supplemental jurisdiction remains discretionary. Section 1367(c) permits a district court to decline supplemental jurisdiction if the state claim raises a novel or complex issue of state law, if the state claim substantially predominates over the claim or claims over which the district court has original jurisdiction, if the district court has dismissed all claims over which it had original jurisdiction, or in other compelling circumstances for declining jurisdiction. The Supreme Court in Carnegie-Mellon University v. Cohill, 484 U.S. 343 (1988), confirmed that a district court has discretion to remand or dismiss pendent state claims even after removal, consistent with Gibbs's admonition that considerations of judicial economy, convenience, fairness to litigants, and comity should guide the decision, particularly when federal claims are dismissed before trial.\n\nApplying these principles, a federal court may exercise supplemental jurisdiction over state law claims whenever they arise from the same case or controversy as a claim within the court's original jurisdiction, subject to the diversity-jurisdiction exceptions in § 1367(b) and the court's discretionary authority under § 1367(c) to decline jurisdiction where the balance of Gibbs factors counsels against retaining the state claims.",
      "segments": [
        {
          "type": "text",
          "text": "A federal court's power to hear state law claims joined with claims that independently support federal jurisdiction is governed by 28 U.S.C. § 1367, which codified and expanded the judge-made doctrines of pendent and ancillary jurisdiction. Under § 1367(a), once a district court has original jurisdiction over any claim in an action, it has supplemental jurisdiction over all other claims that are so related to claims in the action within the court's original jurisdiction that they form part of the same case or controversy under Article III of the United States Constitution. This standard derives from "
        },
        {
          "type": "casename",
          "text": "United Mine Workers of America v. Gibbs"
        },
        {
          "type": "text",
          "text": ", 383 U.S. 715 (1966), which held that state and federal claims must derive from a common nucleus of operative fact such that a plaintiff would ordinarily be expected to try them in one judicial proceeding; if so, the entire action comprises but one constitutional case.\n\nSection 1367(a) further provides that supplemental jurisdiction includes claims involving the joinder or intervention of additional parties, resolving the older ancillary-jurisdiction limits that had constrained claims by or against parties other than the original plaintiff and defendant, as discussed in "
        },
        {
          "type": "casename",
          "text": "Owen Equipment & Erection Co. v. Kroger"
        },
        {
          "type": "text",
          "text": ", 437 U.S. 365 (1978), which had held that ancillary jurisdiction could not be used to circumvent the complete-diversity requirement by allowing a plaintiff to assert a claim against a nondiverse third-party defendant.\n\nSection 1367(b), however, carves out important limits in cases where the district court's original jurisdiction is founded solely on diversity of citizenship under 28 U.S.C. § 1332. In such diversity-only cases, the court has no supplemental jurisdiction over claims by plaintiffs against persons made parties under Rules 14, 19, 20, or 24, or over claims by persons proposed to be joined as plaintiffs under Rule 19 or seeking to intervene as plaintiffs under Rule 24, when exercising jurisdiction over those claims would be inconsistent with the jurisdictional requirements of § 1332. The Supreme Court explained the interaction between § 1367(a) and (b) in "
        },
        {
          "type": "casename",
          "text": "Exxon Mobil Corp. v. Allapattah Services, Inc."
        },
        {
          "type": "text",
          "text": ", 545 U.S. 546 (2005), holding that § 1367 permits supplemental jurisdiction over claims by additional plaintiffs who do not independently satisfy the amount-in-controversy requirement, so long as at least one named plaintiff satisfies the jurisdictional amount and diversity is complete, because § 1367(b) does not exclude such claims from its scope.\n\nEven where the statutory requirements of § 1367(a) are met, the exercise of supplemental jurisdiction remains discretionary. Section 1367(c) permits a district court to decline supplemental jurisdiction if the state claim raises a novel or complex issue of state law, if the state claim substantially predominates over the claim or claims over which the district court has original jurisdiction, if the district court has dismissed all claims over which it had original jurisdiction, or in other compelling circumstances for declining jurisdiction. The Supreme Court in "
        },
        {
          "type": "casename",
          "text": "Carnegie-Mellon University v. Cohill"
        },
        {
          "type": "text",
          "text": ", 484 U.S. 343 (1988), confirmed that a district court has discretion to remand or dismiss pendent state claims even after removal, consistent with Gibbs's admonition that considerations of judicial economy, convenience, fairness to litigants, and comity should guide the decision, particularly when federal claims are dismissed before trial.\n\nApplying these principles, a federal court may exercise supplemental jurisdiction over state law claims whenever they arise from the same case or controversy as a claim within the court's original jurisdiction, subject to the diversity-jurisdiction exceptions in § 1367(b) and the court's discretionary authority under § 1367(c) to decline jurisdiction where the balance of "
        },
        {
          "type": "casename",
          "text": "Gibbs"
        },
        {
          "type": "text",
          "text": " factors counsels against retaining the state claims."
        }
      ],
      "authorities": [
        {
          "id": "a0",
          "rank": 1,
          "kind": "statute",
          "name": "Supplemental jurisdiction",
          "cite": "28 U.S.C. § 1367",
          "year": null,
          "court": null,
          "clusterId": null,
          "href": null,
          "resolution": {
            "status": "resolved",
            "clusterId": null
          },
          "why": "A federal court's power to hear state law claims joined with claims that independently support federal jurisdiction is governed by 28 U.S.C. § 1367, which codified and expanded the judge-made doctrines of pendent and ancillary jurisdiction.",
          "whySource": "answer_prose",
          "relied": true,
          "disclaimed": false,
          "reliedKnown": true,
          "excerpt": "(a)\nExcept as provided in subsections (b) and (c) or as expressly provided otherwise by Federal statute, in any civil action of which the district courts have original jurisdiction, the district courts shall have supplemental jurisdiction over all other claims that are so related to claims in the action within such original jurisdiction that they form part of the same case or controversy under Article III of the United States Constitution. Such supplemental jurisdiction shall include claims that involve the joinder or intervention of additional parties.\n\n(b)\nIn any civil action of which the di",
          "currency": {
            "as_of_date": "2026-04-17",
            "source_release": "119-100",
            "status": null
          }
        },
        {
          "id": "a107200",
          "rank": 2,
          "kind": "case",
          "name": "United Mine Workers of America v. Gibbs",
          "cite": "383 U.S. 715",
          "year": "1966",
          "court": "Supreme Court of the United States",
          "clusterId": 107200,
          "href": "/research/case/107200",
          "resolution": {
            "status": "resolved",
            "clusterId": 107200
          },
          "why": "This standard derives from United Mine Workers of America v. Gibbs, 383 U.S. 715 (1966), which held that state and federal claims must derive from a common nucleus of operative fact such that a plaintiff would ordinarily be expected to try them in one judicial proceeding; if so, the entire action comprises but one constitutional case.",
          "whySource": "answer_prose",
          "relied": true,
          "disclaimed": false,
          "reliedKnown": true,
          "excerpt": null,
          "currency": null
        },
        {
          "id": "a2",
          "rank": 3,
          "kind": "statute",
          "name": "Diversity of citizenship; amount in controversy; costs",
          "cite": "28 U.S.C. § 1332",
          "year": null,
          "court": null,
          "clusterId": null,
          "href": null,
          "resolution": {
            "status": "resolved",
            "clusterId": null
          },
          "why": "Section 1367(b), however, carves out important limits in cases where the district court's original jurisdiction is founded solely on diversity of citizenship under 28 U.S.C. § 1332.",
          "whySource": "answer_prose",
          "relied": true,
          "disclaimed": false,
          "reliedKnown": true,
          "excerpt": "(a)\nThe district courts shall have original jurisdiction of all civil actions where the matter in controversy exceeds the sum or value of $75,000, exclusive of interest and costs, and is between—\n(1)\ncitizens of different States;\n\n(2)\ncitizens of a State and citizens or subjects of a foreign state, except that the district courts shall not have original jurisdiction under this subsection of an action between citizens of a State and citizens or subjects of a foreign state who are lawfully admitted for permanent residence in the United States and are domiciled in the same State;\n\n(3)\ncitizens of",
          "currency": {
            "as_of_date": "2026-04-17",
            "source_release": "119-100",
            "status": null
          }
        },
        {
          "id": "a109904",
          "rank": 4,
          "kind": "case",
          "name": "Owen Equipment & Erection Co. v. Kroger",
          "cite": "437 U.S. 365",
          "year": "1978",
          "court": "Supreme Court of the United States",
          "clusterId": 109904,
          "href": "/research/case/109904",
          "resolution": {
            "status": "resolved",
            "clusterId": 109904
          },
          "why": "Section 1367(a) further provides that supplemental jurisdiction includes claims involving the joinder or intervention of additional parties, resolving the older ancillary-jurisdiction limits that had constrained claims by or against parties other than the original plaintiff and defendant, as discussed in Owen Equipment & Erection Co. v. Kroger, 437 U.S. 365 (1978), which had held that ancillary jurisdiction could not be used to circumvent the complete-diversity requirement by allowing a plaintiff to assert a claim against a nondiverse third-party defendant.",
          "whySource": "answer_prose",
          "relied": true,
          "disclaimed": false,
          "reliedKnown": true,
          "excerpt": null,
          "currency": null
        },
        {
          "id": "a799986",
          "rank": 5,
          "kind": "case",
          "name": "Exxon Mobil Corp. v. Allapattah Services, Inc.",
          "cite": "545 U.S. 546",
          "year": "2005",
          "court": "Supreme Court of the United States",
          "clusterId": 799986,
          "href": "/research/case/799986",
          "resolution": {
            "status": "resolved",
            "clusterId": 799986
          },
          "why": "The Supreme Court explained the interaction between § 1367(a) and (b) in Exxon Mobil Corp. v. Allapattah Services, Inc., 545 U.S. 546 (2005), holding that § 1367 permits supplemental jurisdiction over claims by additional plaintiffs who do not independently satisfy the amount-in-controversy requirement, so long as at least one named plaintiff satisfies the jurisdictional amount and diversity is complete, because § 1367(b) does not exclude such claims from its scope.",
          "whySource": "answer_prose",
          "relied": true,
          "disclaimed": false,
          "reliedKnown": true,
          "excerpt": null,
          "currency": null
        },
        {
          "id": "a111983",
          "rank": 6,
          "kind": "case",
          "name": "Carnegie-Mellon University v. Cohill",
          "cite": "484 U.S. 343",
          "year": "1988",
          "court": "Supreme Court of the United States",
          "clusterId": 111983,
          "href": "/research/case/111983",
          "resolution": {
            "status": "resolved",
            "clusterId": 111983
          },
          "why": "The Supreme Court in Carnegie-Mellon University v. Cohill, 484 U.S. 343 (1988), confirmed that a district court has discretion to remand or dismiss pendent state claims even after removal, consistent with Gibbs's admonition that considerations of judicial economy, convenience, fairness to litigants, and comity should guide the decision, particularly when federal claims are dismissed before trial.",
          "whySource": "answer_prose",
          "relied": true,
          "disclaimed": false,
          "reliedKnown": true,
          "excerpt": null,
          "currency": null
        }
      ],
      "stripped": [],
      "unchecked": [],
      "quotes": [],
      "badge": {
        "verified": true,
        "label": "CiteClerk Verified",
        "tooltip": "Every authority cited resolves to a real document in our corpus, and every quotation shown has been checked against the opinion or statute it comes from — that the words are there, and that they say what the sentence says they do. This is not a check that the answer is correct.",
        "cited": 6,
        "resolved": 6,
        "stripped": 0,
        "unchecked": 0,
        "shown": 6,
        "beyondCap": 0,
        "supportRan": true,
        "declined": false,
        "disclaimed": 0,
        "quotationsChecked": 0,
        "quotationsSupported": 0,
        "quotationsUnsupported": 0,
        "quotationsUnresolved": 0
      },
      "jurisdiction": {
        "effective": null,
        "picker": null,
        "fromPrompt": null,
        "notice": null,
        "source": null
      }
    }
  ],
  [
    "What's the Bluebook citation for Erie Railroad v. Tompkins?",
    {
      "capturedAt": "2026-08-31T23:03:33Z..23:04:57Z",
      "tipSha": "8b8d36e212e1a8bb8437de4c5e54c51a6c2e8aaf",
      "kind": "conversational",
      "reply": "Got it — high confidence. Want a pincite, parallel cite, or short form?",
      "citationPayload": {
        "citation": "Erie R.R. v. Tompkins, 304 U.S. 64 (1938).",
        "parts": {
          "caseName": "Erie R.R. v. Tompkins",
          "volume": "304",
          "reporter": "U.S.",
          "page": "64",
          "court": "",
          "year": "1938"
        },
        "shortName": "Erie R.R.",
        "courtlistenerBestMatch": {
          "caseName": "Erie Railroad v. Tompkins",
          "caseNameFull": "Erie Railroad Co. v. Tompkins",
          "citation": "304 U.S. 64",
          "allCitations": [
            "304 U.S. 64"
          ],
          "citations": [
            "304 U.S. 64"
          ],
          "court": "Supreme Court of the United States",
          "dateFiled": "1938-04-25",
          "absolute_url": null,
          "url": null
        },
        "courtlistenerTopCandidates": [
          {
            "caseName": "Erie Railroad v. Tompkins",
            "caseNameFull": "Erie Railroad Co. v. Tompkins",
            "citation": "304 U.S. 64",
            "allCitations": [
              "304 U.S. 64"
            ],
            "citations": [
              "304 U.S. 64"
            ],
            "court": "Supreme Court of the United States",
            "dateFiled": "1938-04-25",
            "absolute_url": null,
            "url": null
          }
        ],
        "selectionMode": "db-hit",
        "confidence": "high",
        "dataSource": "cold-cases-db",
        "result_type": "confident",
        "candidates": [
          {
            "caseName": "Erie R.R. v. Tompkins",
            "year": 1938,
            "court": "",
            "courtFullName": "Supreme Court of the United States",
            "volume": 304,
            "reporter": "U.S.",
            "page": 64,
            "citation": "Erie R.R. v. Tompkins, 304 U.S. 64 (1938).",
            "mismatches": []
          }
        ],
        "confident_pick_index": 0,
        "filter_state": {
          "jurisdiction": "",
          "courtLevel": "",
          "filterYearRaw": "",
          "yearFrom": null,
          "yearTo": null,
          "edition": "",
          "reporter": "",
          "page": "",
          "year": "",
          "reporterPreference": "regional",
          "filingState": null
        },
        "query": "Erie Railroad v. Tompkins",
        "evaluation": {
          "formatterMode": "deterministic-db-hit",
          "pipelineStage": "db-hit",
          "dbHitYear": 1938,
          "dbHitCourt": "Supreme Court"
        }
      }
    }
  ],
  [
    "Is this citation correct: 28 USC 1332?",
    {
      "capturedAt": "2026-08-31T23:03:33Z..23:04:57Z",
      "tipSha": "8b8d36e212e1a8bb8437de4c5e54c51a6c2e8aaf",
      "kind": "conversational",
      "reply": "I found the source, and the Code and Section Symbol fields need fixing. The correct form is: 28 U.S.C. § 1332.",
      "citationPayload": {
        "result_type": "verify_result",
        "input": "28 USC 1332",
        "sourceType": "statute",
        "verdict": "formatting_errors",
        "canonical": "28 U.S.C. § 1332.",
        "errors": [
          {
            "field": "Code",
            "bbRule": "Bluebook Rule 12",
            "bbRuleNote": "Statutory citations give the title number, code abbreviation with periods, § and section number.",
            "violationType": "The code abbreviation should be \"U.S.C.\" with periods, not \"USC\".",
            "bbDesc": "The code abbreviation should be \"U.S.C.\" with periods, not \"USC\"."
          },
          {
            "field": "Section Symbol",
            "bbRule": "Bluebook Rule 12",
            "bbRuleNote": "Statutory citations give the title number, code abbreviation with periods, § and section number.",
            "violationType": "The section symbol § is missing before the section number.",
            "bbDesc": "The section symbol § is missing before the section number."
          }
        ],
        "existenceStatus": "verified",
        "existenceNote": "Found in the CiteClerk statute corpus."
      }
    }
  ],
  [
    "When do I use id. versus supra?",
    {
      "capturedAt": "2026-08-31T23:03:33Z..23:04:57Z",
      "tipSha": "8b8d36e212e1a8bb8437de4c5e54c51a6c2e8aaf",
      "kind": "conversational",
      "reply": "*Id.* refers to the immediately preceding authority — nothing else has been cited in between. Use it for any authority type, not just cases: *Id.* if you're citing the exact same page, or *Id.* at [page] if it's a different page of that same source. Once another citation intervenes, *id.* is no longer available and you need a short form instead.\n\n*Supra* refers back to a source cited earlier in the document that is *not* immediately preceding — it points the reader back with a cross-reference (e.g., *Smith, supra* note 12, at 45). The key limitation: *supra* is generally not used for cases. For cases, once you're past the \"immediately preceding\" window, you use the short-form case name instead (e.g., *Smith*, 410 U.S. at 120), not *supra*. *Supra* is mainly for secondary sources — books, articles, legislative materials — where a short form by name isn't standard.\n\nSo the quick rule: adjacent citation → *id.*; earlier citation, case → short form case name; earlier citation, non-case → *supra*.\n\nIf you've got a specific chain of citations you're working through, I can help you build the short forms for it.",
      "citationPayload": null
    }
  ],
  [
    "Summarize the opinion in Celotex Corp. v. Catrett.",
    {
      "capturedAt": "2026-08-31T23:03:33Z..23:04:57Z",
      "tipSha": "8b8d36e212e1a8bb8437de4c5e54c51a6c2e8aaf",
      "kind": "research",
      "scope": "all",
      "answerId": null,
      "prose": "In Celotex Corp. v. Catrett, Administratrix of the Estate of Catrett, 477 U.S. 317 (1986), the Supreme Court addressed the burdens the parties bear on a motion for summary judgment under Federal Rule of Civil Procedure 56 and clarified that a moving party need not always produce affirmative evidence negating the nonmoving party's claim. The Court held that the plain language of Rule 56(c) mandates the entry of summary judgment, after adequate time for discovery and upon motion, against a party who fails to make a showing sufficient to establish the existence of an element essential to that party's case, and on which that party will bear the burden of proof at trial.\n\nThe Court reasoned that where the nonmoving party will bear the burden of proof at trial on a dispositive issue, that party must come forward with evidence establishing a genuine issue of material fact for trial; a complete failure of proof on an essential element renders all other facts immaterial. Celotex thus rejected the notion, associated with earlier decisions such as Adickes v. S.H. Kress & Co., 398 U.S. 144 (1970), that a party moving for summary judgment must always support its motion with affidavits or other evidence affirmatively negating the opponent's claim.\n\nThe opinion should be read together with the two companion decisions issued the same term, Anderson v. Liberty Lobby, Inc., 477 U.S. 242 (1986), and Matsushita Electric Industrial Co. v. Zenith Radio Corp., 475 U.S. 574 (1986), which together reshaped summary judgment practice by clarifying the quantum and quality of evidence required to withstand such a motion and by emphasizing that Rule 56 is to be applied in a manner consistent with its purpose of screening out factually unsupported claims and defenses.\n\nCelotex remains the foundational authority establishing that the moving party's burden may be satisfied simply by pointing out to the district court that there is an absence of evidence to support the nonmoving party's case, shifting the burden to the nonmovant to designate specific facts showing a genuine issue for trial.",
      "segments": [
        {
          "type": "text",
          "text": "In "
        },
        {
          "type": "casename",
          "text": "Celotex Corp. v. Catrett, Administratrix of the Estate of Catrett"
        },
        {
          "type": "text",
          "text": ", 477 U.S. 317 (1986), the Supreme Court addressed the burdens the parties bear on a motion for summary judgment under Federal Rule of Civil Procedure 56 and clarified that a moving party need not always produce affirmative evidence negating the nonmoving party's claim. The Court held that the plain language of Rule 56(c) mandates the entry of summary judgment, after adequate time for discovery and upon motion, against a party who fails to make a showing sufficient to establish the existence of an element essential to that party's case, and on which that party will bear the burden of proof at trial.\n\nThe Court reasoned that where the nonmoving party will bear the burden of proof at trial on a dispositive issue, that party must come forward with evidence establishing a genuine issue of material fact for trial; a complete failure of proof on an essential element renders all other facts immaterial. Celotex thus rejected the notion, associated with earlier decisions such as "
        },
        {
          "type": "casename",
          "text": "Adickes"
        },
        {
          "type": "text",
          "text": " v. S.H. Kress & Co., 398 U.S. 144 (1970), that a party moving for summary judgment must always support its motion with affidavits or other evidence affirmatively negating the opponent's claim.\n\nThe opinion should be read together with the two companion decisions issued the same term, "
        },
        {
          "type": "casename",
          "text": "Anderson v. Liberty Lobby, Inc."
        },
        {
          "type": "text",
          "text": ", 477 U.S. 242 (1986), and Matsushita Electric Industrial Co. v. Zenith Radio Corp., 475 U.S. 574 (1986), which together reshaped summary judgment practice by clarifying the quantum and quality of evidence required to withstand such a motion and by emphasizing that Rule 56 is to be applied in a manner consistent with its purpose of screening out factually unsupported claims and defenses.\n\nCelotex remains the foundational authority establishing that the moving party's burden may be satisfied simply by pointing out to the district court that there is an absence of evidence to support the nonmoving party's case, shifting the burden to the nonmovant to designate specific facts showing a genuine issue for trial."
        }
      ],
      "authorities": [
        {
          "id": "a111722",
          "rank": 1,
          "kind": "case",
          "name": "Celotex Corp. v. Catrett, Administratrix of the Estate of Catrett",
          "cite": "477 U.S. 317",
          "year": "1986",
          "court": "Supreme Court of the United States",
          "clusterId": 111722,
          "href": "/research/case/111722",
          "resolution": {
            "status": "resolved",
            "clusterId": 111722
          },
          "why": "In Celotex Corp. v. Catrett, Administratrix of the Estate of Catrett, 477 U.S. 317 (1986), the Supreme Court addressed the burdens the parties bear on a motion for summary judgment under Federal Rule of Civil Procedure 56 and clarified that a moving party need not always produce affirmative evidence negating the nonmoving party's claim.",
          "whySource": "answer_prose",
          "relied": true,
          "disclaimed": false,
          "reliedKnown": true,
          "excerpt": null,
          "currency": null
        },
        {
          "id": "a111719",
          "rank": 2,
          "kind": "case",
          "name": "Anderson v. Liberty Lobby, Inc.",
          "cite": "477 U.S. 242",
          "year": "1986",
          "court": "Supreme Court of the United States",
          "clusterId": 111719,
          "href": "/research/case/111719",
          "resolution": {
            "status": "resolved",
            "clusterId": 111719
          },
          "why": "The opinion should be read together with the two companion decisions issued the same term, Anderson v. Liberty Lobby, Inc., 477 U.S. 242 (1986), and Matsushita Electric Industrial Co. v. Zenith Radio Corp., 475 U.S. 574 (1986), which together reshaped summary judgment practice by clarifying the quantum and quality of evidence required to withstand such a motion and by emphasizing that Rule 56 is to be applied in a manner consistent with its purpose of screening out factually unsupported claims and defenses.",
          "whySource": "answer_prose",
          "relied": true,
          "disclaimed": false,
          "reliedKnown": true,
          "excerpt": null,
          "currency": null
        },
        {
          "id": "a111620",
          "rank": 3,
          "kind": "case",
          "name": "Matsushita Electric Industrial Co., Ltd. v. Zenith Radio Corporation",
          "cite": "475 U.S. 574",
          "year": "1986",
          "court": "Supreme Court of the United States",
          "clusterId": 111620,
          "href": "/research/case/111620",
          "resolution": {
            "status": "resolved",
            "clusterId": 111620
          },
          "why": "The opinion should be read together with the two companion decisions issued the same term, Anderson v. Liberty Lobby, Inc., 477 U.S. 242 (1986), and Matsushita Electric Industrial Co. v. Zenith Radio Corp., 475 U.S. 574 (1986), which together reshaped summary judgment practice by clarifying the quantum and quality of evidence required to withstand such a motion and by emphasizing that Rule 56 is to be applied in a manner consistent with its purpose of screening out factually unsupported claims and defenses.",
          "whySource": "answer_prose",
          "relied": true,
          "disclaimed": false,
          "reliedKnown": true,
          "excerpt": null,
          "currency": null
        },
        {
          "id": "a108153",
          "rank": 4,
          "kind": "case",
          "name": "Adickes v. S. H. Kress & Co.",
          "cite": "398 U.S. 144",
          "year": "1970",
          "court": "Supreme Court of the United States",
          "clusterId": 108153,
          "href": "/research/case/108153",
          "resolution": {
            "status": "resolved",
            "clusterId": 108153
          },
          "why": "Celotex thus rejected the notion, associated with earlier decisions such as Adickes v. S.H. Kress & Co., 398 U.S. 144 (1970), that a party moving for summary judgment must always support its motion with affidavits or other evidence affirmatively negating the opponent's claim.",
          "whySource": "answer_prose",
          "relied": true,
          "disclaimed": false,
          "reliedKnown": true,
          "excerpt": null,
          "currency": null
        }
      ],
      "stripped": [],
      "unchecked": [],
      "quotes": [],
      "badge": {
        "verified": true,
        "label": "CiteClerk Verified",
        "tooltip": "Every authority cited resolves to a real document in our corpus, and every quotation shown has been checked against the opinion or statute it comes from — that the words are there, and that they say what the sentence says they do. This is not a check that the answer is correct.",
        "cited": 6,
        "resolved": 4,
        "stripped": 0,
        "unchecked": 0,
        "shown": 4,
        "beyondCap": 0,
        "supportRan": true,
        "declined": false,
        "disclaimed": 0,
        "quotationsChecked": 0,
        "quotationsSupported": 0,
        "quotationsUnsupported": 0,
        "quotationsUnresolved": 0
      },
      "jurisdiction": {
        "effective": null,
        "picker": null,
        "fromPrompt": null,
        "notice": null,
        "source": null
      }
    }
  ],
  [
    "What plans does CiteClerk offer?",
    {
      "capturedAt": "2026-08-31T23:03:33Z..23:04:57Z",
      "tipSha": "8b8d36e212e1a8bb8437de4c5e54c51a6c2e8aaf",
      "kind": "conversational",
      "reply": "Here's the current lineup — five plans, no more:\n\n**Free** — $0/mo, 10 citations/month (20/month with a verified .edu email).\n\n**Student** — $9/mo or $84/yr, requires a verified .edu email, 100 citations/month.\n\n**Student Ultra** — $20/mo or $192/yr, .edu required, 250 citations/month, 10 research queries/month, 1 Doc Check doc/month, 1 draft/month.\n\n**Attorney** — $30/mo or $300/yr (most popular), 500 citations/month, 20 research queries/month, 3 Doc Check docs/month, 2 drafts/month.\n\n**Attorney Ultra** — $60/mo or $600/yr, 1,000 citations/month, 50 research queries/month, 5 Doc Check docs/month, 3 drafts/month.\n\nAll 7 source types, Advanced Options, and reporter preference are included on every plan — even Free. Note that research queries, Doc Checks, and drafts only start appearing at Student Ultra and up. Annual billing saves you up to 22%.\n\nA couple of things worth flagging: there's no Partner or Firm plan — those aren't offered. And if you want specifics on custom/volume pricing or anything the pricing page doesn't cover, that's a billing@citeclerk.com question (or check the contact page).\n\nAnything in particular you're trying to figure out — like which tier fits your usage?",
      "citationPayload": null
    }
  ]
];

const TABLE = new Map(ENTRIES);

/** The frozen answer for this EXACT text, or null. Null means: run a live turn. */
export function frozenAnswerFor(text) {
  return TABLE.get(text) ?? null;
}
export const FROZEN_COUNT = TABLE.size;
